import { AssignKioskRepository } from '../data/assign-kiosk-repository';
import { KioskDetailsResponse } from '../types/assign-kiosk-types';

export interface GetKioskDetailsResult {
  data: KioskDetailsResponse | null;
  hasError: boolean;
  errorMessage?: string;
}

export class GetKioskDetailsUseCase {
  constructor(private readonly repository: AssignKioskRepository) {}

  async execute(machineId: string): Promise<GetKioskDetailsResult> {
    try {
      const data = await this.repository.getKioskDetails(machineId);
      return { data, hasError: false };
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to load kiosk details';
      return { data: null, hasError: true, errorMessage };
    }
  }
}
